var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex1",staticStyle:{"height":"100%"}},[_c('Title',{attrs:{"title":'SOC值区间'}}),(_vm.showcdata)?_c('echarts',{attrs:{"id":'SOCValueRange',"options":_vm.cdata}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }